import { render, staticRenderFns } from "./BuyerBillingCharts.vue?vue&type=template&id=e01fecd8"
import script from "./BuyerBillingCharts.vue?vue&type=script&lang=js"
export * from "./BuyerBillingCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports